import { Inject, Injector } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

export class Helper {
    public static injector: Injector;
    constructor(private route: ActivatedRoute) { }
    static getFromLocalStorage(key: string) {
        return JSON.parse(localStorage.getItem(key));
    }
    public static buildEnumeric<T extends Record<string, any>>(obj: T): { [K in keyof T]: string } {
        const result: { [K in keyof T]: string } = {} as { [K in keyof T]: string };
        Object.keys(obj).forEach(key => result[key as keyof T] = key);
        return result;
    }
}